import React from 'react';
import { createRoot } from 'react-dom/client';
import LandingPage from './pages/LandingPage';
import {
  HashRouter,
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";
import reportWebVitals from './reportWebVitals';

const App = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
      </Routes>
    </HashRouter>
  );
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

reportWebVitals();